var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-config-panel"},_vm._l((_vm.series.slice(0, this.viewport.cnt)),function(s,sIdx){return _c('stat-panel',{key:sIdx,attrs:{"config":_vm.config,"series":s,"palette":_vm.palette,"viewport":_vm.viewport}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }